<script>
import { useSectionStore } from "../store/SectionStore";
import RetrieveJSONMixin from "./RetrieveJSONMixin.vue";

export default {
  async mounted() {
    let res = await this.execRetrieveJson("json/dropdowns.json");
    this.genderList = res.sexes;
    this.prenatalSampleTypeList = res.prenatalSampleTypes;
    this.sampleTypeList = res.sampleTypes;
    this.ethnicityList = res.ethnicities;
    this.countryList = res.countries;
    this.titleList = res.titles;
    this.yesNoUnknownList = res.yesNoUnknown;
    this.yesNoUncertainList = res.yesNoUncertain;
    this.familyRolesList = res.familyRoles;
    this.supportedTests = res.supportedTests;
    this.sendBillToList = res.sendBillTo;
    this.prenatalAndPostnatalSampleTypeList = [
      ...this.sampleTypeList,
      ...this.prenatalSampleTypeList,
    ];
  },
  mixins: [RetrieveJSONMixin],
  computed: {
    probandSampleTypeList() {
      return this.sampleTypeList;
    },

    probandPrenatalSampleTypeList() {
      return this.prenatalSampleTypeList;
    },

    stateList() {
      let countryObj = this.findObjectByValueKey(
        this.countryList,
        this.country
      );
      return countryObj !== null ? countryObj["states"] : [];
    },
  },
  data() {
    return {
      genderList: [],
      ethnicityList: [],
      countryList: [],
      titleList: [],
      yesNoUnknownList: [],
      prenatalSampleTypeList: [],
      sampleTypeList: [],
      prenatalAndPostnatalSampleTypeList: [],
      yesNoUncertainList: [],
      familyRolesList: [],
      supportedTests: [],
      sendBillToList: [],
    };
  },
  methods: {
    findObjectByValueKey(objList, valueKey) {
      let objs = [];
      for (let obj of objList) {
        if ("value" in obj && valueKey === obj.value) {
          objs.push(obj);
        }
      }
      if (objs.length > 1) {
        throw new Error(
          `Found non unique 'value' key in ${objList} for value ${valueKey}`
        );
      } else if (objs.length === 1) {
        return objs[0];
      } else {
        return null;
      }
    },

    sampleTypeName(sampleType, isParent) {
      const isPrenatal = useSectionStore().isPrenatal;
      const sampleList =
        isPrenatal && !isParent
          ? this.prenatalSampleTypeList
          : this.sampleTypeList;
      if (typeof sampleList !== "undefined" && sampleList.length > 0) {
        const foundSample = sampleList.find((val) => val.value === sampleType);
        return foundSample ? foundSample.displayText : "";
      } else return "";
    },
    sendBillToName(sendBillToValue) {
      if (sendBillToValue === "MEDICARE") {
        return "Medicare";
      }
      return typeof this.sendBillToList !== "undefined" &&
        this.sendBillToList.length > 0
        ? this.sendBillToList.find((person) => person.value === sendBillToValue)
            .displayText
        : "";
    },
    async getDropDownMapping(byValue, lowerKey) {
      // Crawl through the object tree finding all displayText and value pairs
      // If byValue is true then use values as keys otherwise use "Displayed Text"
      // If lowerkey is set then call toLowerCase on the key
      let res = await this.execRetrieveJson("json/dropdowns.json");
      let obj = {};
      let displayTextKey = "displayText";
      let valueKey = "value";
      function getValueDisplayText(v) {
        if (v instanceof Array) {
          for (let o of v) {
            if (o instanceof Object) {
              if (displayTextKey in o && valueKey in o) {
                let value = o[valueKey];
                let displayText = o[displayTextKey];
                if (byValue === true) {
                  if (lowerKey === true) {
                    value = value.toLowerCase();
                  }
                  obj[value] = displayText;
                } else {
                  if (lowerKey === true) {
                    displayText = displayText.toLowerCase();
                  }
                  obj[displayText] = value;
                }
              }
              for (let k of Object.keys(o)) {
                if (k == displayTextKey || k == valueKey) {
                  continue;
                } else {
                  getValueDisplayText(o[k]);
                }
              }
            }
          }
        } else {
          for (let value of Object.values(v)) {
            getValueDisplayText(value);
          }
        }
      }
      getValueDisplayText(res);
      return obj;
    },
  },
};
</script>
